var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"list-resource"},_vm._l((_vm.resources),function(resource,key){return _c('li',{key:key},[_c('v-text-field',{attrs:{"label":resource.name},on:{"input":_vm.setValue},model:{value:(resource['uniq']),callback:function ($$v) {_vm.$set(resource, 'uniq', $$v)},expression:"resource['uniq']"}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }